
window.EVENT = {
    // global events -----------------------
    AppScroll: '',
    StopScroll: '',
    AppResize: '',
    ImageLoad: '',
    // Swiper ---------------------
    SwiperTransitionStart: '',
    SwiperTransitionEnd: '',
    SwiperLazyLoaded: '',
    // ScrollToTarget
    ScrollToTarget: ''
};

for (let e in EVENT) EVENT[e] = e;

export default EVENT;
